export interface SanitizeNumberOptions {
  /** thêm dấu `.` `,` — tiền kiểu Việt (1.000.000), phần trăm (2,5) */
  decimal?: boolean
  /** giữ MỘT dấu `-` ở đầu (số âm); dấu `-` ở chỗ khác bị bỏ */
  negative?: boolean
}

/** Bỏ mọi ký tự không được phép trong ô số — dùng chung cho `NumberInput` và ô số của form hồ sơ (luật 1d) */
export function sanitizeNumber(text: string, { decimal = false, negative = false }: SanitizeNumberOptions = {}): string {
  const digits = text.replace(decimal ? /[^\d.,]/g : /\D/g, '')
  return negative && text.trimStart().startsWith('-') ? `-${digits}` : digits
}
